import ctl from "@netlify/classnames-template-literals";

export const phoneInputWrapper = ctl(`
  relative
  rounded-2xl
  bg-neutral-800
  focus-within:ring-1
  focus-within:ring-white
`);

export const input = (showValidation: boolean) =>
  ctl(`
  !rounded-r-2xl
  !px-2
  !py-3
  !h-auto
  w-full
  !font-sans
  !text-base
  !bg-transparent
  !text-white
  placeholder:!text-neutral-400
  !border-0
  focus:!border-0
  focus:!outline-none
  focus:!ring-0
  ${showValidation ? "" : ""}
`);

export const countrySelectorButton = (showValidation: boolean) =>
  ctl(`
  !rounded-l-2xl
  !px-4
  !py-3
  !h-auto
  !bg-neutral-800
  !border-transparent
  !border-t-transparent
  !border-l-transparent
  !border-b-transparent
  focus-within:!border-white
  focus-within:!border-t-white
  focus-within:!border-l-white
  focus-within:!border-b-white
  ${showValidation ? "!border-red-500" : ""}
`);

export const countrySelectorListItem = ctl(`
  !bg-neutral-800
  !px-4
  !py-2
  hover:!bg-neutral-700
`);

export const countrySelectorListItemCountryName = ctl(`
  !font-sans
  !text-base
  !text-white
`);

export const countrySelectorListItemDialCode = ctl(`
  !font-sans
  !text-base
  !text-neutral-400
`);

export const dialCodePreview = (showValidation: boolean) =>
  ctl(`
  !font-sans
  !text-base
  !text-neutral-400
  !bg-neutral-800
  !border-transparent
  ${showValidation ? "!border-red-500" : ""}
`);
